import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Spin, Typography, Tooltip } from "antd";
import { EyeOutlined, ReloadOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { displaySecret } from "../../actions";
import OidcDetails from "./OidcDetails";

const { Paragraph } = Typography;

const ViewSecretModal = ({
  handleRegenerate,
  registrationId,
  displaySecret,
  disabled = false,
}) => {
  const [viewedRegistration, setViewedRegistration] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const viewSecret = async () => {
    setLoading(true);
    try {
      const response = await displaySecret(registrationId);
      if (response?.payload?.data) {
        const { clientId, secret } = response.payload.data;
        setViewedRegistration({ clientId, secret });
      }
    } finally {
      setLoading(false);
    }
  };

  const clearDetails = () => {
    setViewedRegistration(undefined);
    setModalVisible(false);
  };

  return (
    <>
      <Tooltip title="View or regenerate secret">
        <Button
          id="viewSecretButton"
          color="gold"
          variant="filled"
          icon={<EyeOutlined />}
          onClick={() => setModalVisible(true)}
          disabled={disabled}
          style={{ marginRight: 8 }}
        />
      </Tooltip>
      <Modal
        open={modalVisible}
        onCancel={clearDetails}
        title="View or Regenerate Secret"
        onOk={handleRegenerate}
        okText="Regenerate Secret"
        cancelText="Cancel"
        cancelButtonProps={{
          onClick: clearDetails,
          type: "default",
          color: "gray",
          variant: "filled",
        }}
        okButtonProps={{
          type: "primary",
          color: "blue",
          variant: "filled",
          icon: <ReloadOutlined />,
        }}
        width={600}
        centered
        closable
      >
        <div style={{ marginBottom: "1rem" }}>
          <Paragraph>
            You can regenerate the client secret. This will invalidate the
            previous one. Otherwise, you can view the current secret.
          </Paragraph>

          {!viewedRegistration && !loading && (
            <Button
              color="gold"
              variant="outlined"
              id="viewSecretTriggerButton"
              onClick={viewSecret}
              disabled={disabled}
              icon={<EyeOutlined />}
              block
              style={{
                marginTop: "1rem",
                marginBottom: "1rem",
              }}
            >
              View
            </Button>
          )}
        </div>

        <div>
          {viewedRegistration && (
            <div style={{ marginBottom: "2rem" }}>
              <OidcDetails
                clientId={viewedRegistration.clientId}
                secret={viewedRegistration.secret}
              />
            </div>
          )}
          {loading && (
            <div style={{ textAlign: "center", marginTop: 20 }}>
              <Spin />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

ViewSecretModal.propTypes = {
  handleRegenerate: PropTypes.func.isRequired,
  displaySecret: PropTypes.func.isRequired,
  registrationId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default connect(null, { displaySecret })(ViewSecretModal);
